'use strict';
import Barba from 'barba.js';
import Env from '../base/env.js';
import tinycolor from 'tinycolor2'

let page

class Page
{
    constructor(view='')
    {
        this.view = view
        this.$btnBuy = this.view.querySelector('.jsTracker--buy')
        this.$cover = this.view.querySelector('.jsCover')
        this.classView = 'currentView--good'
        // Fns
        this.events()

    }

    events()
    {
        this.$btnBuy.addEventListener('click',()=>{
            gtag('event', 'purchase', {
                'event_category': 'engagement',
                'event_label': 'Buy Button',
            });
        })
    }

    finalize()
    {
        this.getBg()
        setTimeout(() => {
            if(Env.isVisiting === true) {
                this.intro()
            }
        }, 100);
        Env.framework.UI.pinRefresh()
    }

    getBg()
    {
        if(Env.framework.popin.ENABLED == false) {
            const getBg = this.$cover.getAttribute('data-bgcolor')
            if(tinycolor(getBg).isDark()){
                Env.$html.classList.add('cover--good')
            }
        }
    }

    intro()
    {
        console.log('intro good');
    }

}

page = Barba.BaseView.extend({
    namespace: 'good',
    node: undefined,
    onEnter: function() {
        this.node = new Page(this.container)
        Env.$html.classList.add(this.node.classView)
    },
    onEnterCompleted:function()
    {
        this.node.finalize()
    },
    onLeaveCompleted: function()
    {
        if(this.container.getAttribute('data-namespace') != this.namespace)
        {
            Env.$html.classList.remove(this.node.classView)
        }
    }
});

export default page;